import { get, uniqBy } from 'lodash'
import activeAward from 'helpers/activeAward'
import { getLeaderId } from 'utils/token'

export function map(fields) {
  return fields.map(item => ({
    label: item.translatedName || item.name,
    value: item.id
  }))
}

export function mapActivitiesParent(fields) {
  return uniqBy(fields, 'parent.id')
    .filter(item => item.parent)
    .map(item => item.parent)
}

export function mapAwards(fields) {
  return fields
    .map(item => ({
      label: get(item, 'translationText'),
      value: item.value
    }))
    .filter(item => item.label)
}

export function mapCodeList(fields) {
  return fields.map(item => ({
    label: item.textTranslated,
    value: item.value
  }))
}

export function mapParticipant(fields, opts = {}) {
  let inputFields = fields

  if (opts.awardLevelValue) {
    inputFields = inputFields.filter(participant => {
      const activeIndex = activeAward(...fields) || 0

      return (
        get(participant, `awards[${activeIndex}].awardLevel.value`) ===
        opts.awardLevelValue
      )
    })
  }

  return inputFields.map(item => ({
    label: `${get(item, 'firstName')} ${get(item, 'lastName')} <${get(
      item,
      'email'
    )}>`,
    value: item.id
  }))
}

export function mapAllowedRoles(fields) {
  return fields.map(item => ({
    label: item.translationText,
    value: item.value
  }))
}

export function mapLeaders(leaders, user, intl, includeEmpty = false) {
  const awardLeaderList = leaders.list.map(item => {
    const name =
      get(item, 'person.firstName') + ' ' + get(item, 'person.lastName')
    const isMe =
      item.id === getLeaderId(user)
        ? ' ' + intl.formatMessage({ id: 'label.me', defaultMessage: 'me' })
        : ''

    return {
      value: item.id,
      label: name + isMe
    }
  })

  if(includeEmpty) {
    const label = intl.formatMessage({
      id: 'label.blank_any_level',
      defaultMessage: 'BLANK on any level'
    })

    awardLeaderList.unshift({ value: null, label })
  }

  return awardLeaderList || []
}


export function mapLabels(labelList, withOrgName = false, includeEmpty = false, intl) {
  const result = labelList && labelList.map(item => {
    return {
      value: item.id,
      label: withOrgName ? get(item, 'name') + ' (' + get(item, 'organization.name') + ')' : get(item, 'name')
    }
  })

  if(includeEmpty) {
    const label = intl.formatMessage({
      id: 'label.no_label',
      defaultMessage: 'No label'
    })

    result.unshift({ value: null, label })
  }

  return result || []
}

export function mapAwardUnits(awardUnits) {
  return awardUnits.list.map(item => {
    const name = get(item, 'name')

    return {
      value: item.id,
      label: name
    }
  }) || []
}
